export default "__VITE_ASSET__MOI271xT__"